import { FormControl, InputLabel, ListItemIcon, MenuItem, Select, Typography, Box } from "@mui/material";
import React, { useState } from "react";
import { Networks } from "../enums/networks.js";
import { CryptoCurrencies } from "../enums/CryptoCurrenciesCombo.js";

const ComboNetwork = ({ setNetwork, network, cryptoCurrency }) => {
	const handleChange = (e) => {
		setNetwork(e.target.value);
	};

	let networks = [];

	switch (cryptoCurrency) {
		case CryptoCurrencies.BITCOIN:
			networks = [
				{
					network: Networks.BITCOIN,
					name: Networks.BITCOIN,
				},
				{
					network: Networks.LIGHTNING,
					name: Networks.LIGHTNING,
				},
			];
			break;
		case CryptoCurrencies.ETHEREUM:
			networks = [
				{
					network: Networks.ETHEREUM,
					name: Networks.ETHEREUM,
				},
				{
					network: Networks.BASE,
					name: Networks.BASE,
				},
			];
			break;
		case CryptoCurrencies.USDT:
			networks = [
				{
					network: Networks.ETHEREUM,
					name: Networks.ETHEREUM,
				},
				{
					network: Networks.TRON,
					name: Networks.TRON,
				},
			];
			break;
		case CryptoCurrencies.USDC:
			networks = [
				{
					network: Networks.ETHEREUM,
					name: Networks.ETHEREUM,
				},
				{
					network: Networks.BASE,
					name: Networks.BASE,
				},
			];
			break;
		case CryptoCurrencies.TRX:
			networks = [
				{
					network: Networks.TRON,
					name: Networks.TRON,
				},
			];
			break;
		case CryptoCurrencies.XRP:
			networks = [
				{
					network: Networks.RIPPLE,
					name: Networks.RIPPLE,
				},
			];
			break;
		case CryptoCurrencies.LITECOIN:
			networks = [
				{
					network: Networks.LITECOIN,
					name: Networks.LITECOIN,
				},
			];
			break;
		case CryptoCurrencies.DOGECOIN:
			networks = [
				{
					network: Networks.DOGECOIN,
					name: Networks.DOGECOIN,
				},
			];
			break;
		default:
			networks = [];
			break;
	}

	return (
		<FormControl sx={{ width: "100%", alignItems: "center", display: "flex" }} fullWidth>
			<Box sx={{ width: "100%", textAlign: "left", marginTop: 2, marginBottom: 1 }}>
				<Typography component="h2" variant="subtitle2" gutterBottom>Select Network</Typography>
			</Box>
			<Select
				size="small"
				value={network ?? "first"}
				onChange={handleChange}
				sx={{ borderRadius: 6, display: "flex", minWidth: 300 }}
				fullWidth
			>
				<MenuItem value={"first"} key={-1} component="div" style={{ display: "flex" }} disabled>
					<Box sx={{ display: "flex" }}>
						<Typography sx={{ fontSize: "18px", color: "#CCCCCC" }} component="div">
							{"Select Network"}
						</Typography>
					</Box>
				</MenuItem>
				{networks?networks.map((nw) => {
					return (
						<MenuItem value={nw.network ?? ""} key={nw.network} component="div" style={{ display: "flex" }}>
							<Box sx={{ display: "flex" }}>
								<Typography sx={{ fontSize: "18px" }} component="div">
									{nw.name}
								</Typography>
							</Box>
						</MenuItem>
					);
				}):null}
			</Select>
		</FormControl>
	);
};

export default ComboNetwork;
